var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app"},[_c('main',{staticClass:"min-h-screen"},[(_vm.appReady)?_c('div',[_c('router-view')],1):_vm._e()]),_c('app-snackbar'),_c('app-service-worker'),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }